import { SET_IDENTITY_DOCS } from '../actions/actions';
import produce from 'immer';

const INITIAL_STATE = {
  identityDocs: []
};

export default function identityTagsReducer(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_IDENTITY_DOCS: {
        draft.identityDocs = action.payload;
        break;
      }

      default:
        return state;
    }
  });
}
